<template>
  <section class="container pb-8">
    <!-- 套裝列表 -->
    <div class="row mb-4">
      <div class="col-12 col-md-6 col-lg-4 mb-3 ml-auto">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            v-model="args.keyWord"
            placeholder="套裝名稱查詢"
            aria-label="套裝名稱查詢"
            @keydown.enter="search(0)"
          />
          <div class="input-group-prepend">
            <button class="btn btn-outline-secondary" type="button" @click="search(0)">
              <i class="fa fa-search text-muted" aria-hidden="true"></i>
            </button>
            <button class="btn btn-outline-secondary" type="button" @click="search(1)">
              清除
            </button>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="error-bg mb-3" v-if="coursesList.length === 0 && !isLoading">
          <div>查無已購買的套裝課程</div>
        </div>
        <ul class="course-list" v-else>
          <li
            v-for="(course, index) in coursesList"
            :key="index"
            class="course-item"
            @click="selectCourse(course)"
          >
            <div class="course-item__content">
              <h5 class="course-item__title">{{ course.courseName }}</h5>
              <p class="course-item__deadline">
                <i class="fa fa-calendar mr-2"></i>
                <template v-if="course.selectedStartDate && course.selectedEndDate">
                  作答期限：{{
                    course.selectedStartDate | toTaipei | moment('YYYY-MM-DD')
                  }} - {{
                    course.selectedEndDate | toTaipei | moment('YYYY-MM-DD')
                  }}
                </template>
                <template v-else>
                  作答期限：無可作答試卷
                </template>
              </p>
            </div>
            <div class="course-item__action">
              <button class="btn btn-primary">
                試卷清單
              </button>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 分頁 -->
    <Pagination
      @GetList="getList()"
      :page.sync="pagination.pageIndex"
      :page-row="pagination.pageSize"
      :total-count="pageInfo.count"
    />
  </section>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import { GetStudentPurchasedCoursesList } from '@/api/EssayPapersApi';

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      args: { keyWord: '' },
      pagination: {
        pageIndex: 1,
        pageSize: 10,
        data: {
          keyWord: '',
        },
      },
      pageInfo: {
        count: 0,
        data: [],
      },
      coursesList: [],
      isLoading: false,
    };
  },
  async activated() {
    if (!this.$route.meta.isBack) {
      this.resetData();
    }

    this.getCoursesList();
  },
  methods: {
    // 重置資料
    resetData() {
      this.args = { keyWord: '' };
      this.pagination = {
        pageIndex: 1,
        pageSize: 10,
        data: {
          keyWord: '',
        },
      };
      this.pageInfo = {
        count: 0,
        data: [],
      };
    },

    // 搜尋
    search(isClear = 0) {
      this.pagination.pageIndex = 1;
      if (isClear === 0) {
        this.pagination.data = { ...this.args };
      }
      if (isClear === 1) {
        this.args = { keyWord: '' };
        this.pagination.data = { keyWord: '' };
      }
      this.getCoursesList();
    },

    // 取得套裝列表
    getCoursesList() {
      this.isLoading = true;
      const data = {
        pageIndex: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize,
        data: { courseName: this.args.keyWord },
      };

      GetStudentPurchasedCoursesList(data)
        .then((response) => {
          if (response.data.statusCode === 0) {
            this.coursesList = response.data.data || [];
            this.pageInfo.count = response.data.count || 0;
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    // 取得列表（提供給分頁使用）
    getList() {
      this.getCoursesList();
    },

    // 選擇套裝
    selectCourse(course) {
      this.$router.push({
        name: 'essayPapersList',
        params: {
          courseId: course.courseId,
          courseName: course.courseName,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.course-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.course-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  width: 100%;
  padding: 20px;
  margin-bottom: 20px;

  border-radius: 5px;

  box-shadow: 0 5px 20px -3px rgba(#000, .2);

  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 8px 25px -3px rgba(#000, .3);
    transform: translateY(-2px);
  }

  &__content {
    flex: 1;
    min-width: 0;
  }

  &__title {
    font-size: 18px;
    font-weight: 600;
    color: #212529;
    margin-bottom: 4px;
  }

  &__deadline {
    font-size: 14px;
    color: #777777;
    margin-bottom: 0;
  }

  &__info {
    font-size: 14px;
    color: #777777;
    margin-bottom: 0;
  }

  &__action {
    flex-shrink: 0;
    margin-left: 20px;
  }
}

// 手機版響應式樣式
@media (max-width: 768px) {
  .course-item {
    flex-direction: column;
    text-align: center;

    &__action {
      margin-left: 0;
      margin-top: 16px;
      width: 100%;

      .btn {
        width: 100%;
      }
    }
  }
}
</style>
